module.exports = __webpack_public_path__ + "media/application/images/bcorp-logo-2-f25bdd0104a9658ee599daad908e6c51.png";